import { render, staticRenderFns } from "./PendingJoinRequestDataTable.vue?vue&type=template&id=e279857e"
import script from "./PendingJoinRequestDataTable.vue?vue&type=script&lang=js"
export * from "./PendingJoinRequestDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports